import { render, staticRenderFns } from "./allocateVIBANModal.vue?vue&type=template&id=77ea2f1c&scoped=true&"
import script from "./allocateVIBANModal.vue?vue&type=script&lang=js&"
export * from "./allocateVIBANModal.vue?vue&type=script&lang=js&"
import style0 from "./allocateVIBANModal.vue?vue&type=style&index=0&id=77ea2f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea2f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ea2f1c')) {
      api.createRecord('77ea2f1c', component.options)
    } else {
      api.reload('77ea2f1c', component.options)
    }
    module.hot.accept("./allocateVIBANModal.vue?vue&type=template&id=77ea2f1c&scoped=true&", function () {
      api.rerender('77ea2f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/allocateVIBANModal.vue"
export default component.exports